import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDateInputMask]',
  standalone: true,
})
export class DateInputFormatDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value']) onInputChange(value: string): void {
    if (value.includes('/')) return;

    const digits = value.replace(/\D/g, '');
    if (digits.length === 8) {
      const formatted = `${digits.substring(0, 2)}/${digits.substring(2, 4)}/${digits.substring(4, 8)}`;
      this.el.nativeElement.value = formatted;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }
}
